module.exports = __webpack_public_path__ + "img/photo-17.3bc22bc8.jpg";